import { render, staticRenderFns } from "./payment_gateway_configuration.vue?vue&type=template&id=138151a8&"
import script from "./payment_gateway_configuration.vue?vue&type=script&lang=js&"
export * from "./payment_gateway_configuration.vue?vue&type=script&lang=js&"
import style0 from "./payment_gateway_configuration.vue?vue&type=style&index=0&id=138151a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports